import classNames from 'classnames'
import * as React from 'react'

import type {BuildId} from '../../../../types'
import type {BuildLogMessage} from '../BuildLog.types'
import {showDuration} from '../BuildLog.utils'

import LogMessage from './LogMessage/LogMessage'

import styles from './BuildLogMessages.css'

type Props = {
  className?: string | null | undefined
  messageClassName?: string | null | undefined
  messages: ReadonlyArray<BuildLogMessage> | null | undefined
  buildId?: BuildId
  treeView?: boolean
  breakLines?: boolean
  minimiseLevels?: boolean
  parseLinks?: boolean
  withDuration?: boolean
}

class BuildLogMessages extends React.PureComponent<Props> {
  render(): React.ReactNode {
    const {
      messages,
      className,
      messageClassName,
      minimiseLevels,
      treeView,
      breakLines,
      parseLinks = true,
      withDuration,
    } = this.props

    if (!messages) {
      return null
    }

    let minLevel: number

    if (minimiseLevels === true) {
      messages.forEach((message: BuildLogMessage) => {
        if (!minLevel || minLevel > message.level) {
          minLevel = message.level
        }
      })
    }

    return (
      <div className={classNames(styles.messages, className)} data-test-build-log-messages>
        {messages.map((message: BuildLogMessage, index: number) => (
          <LogMessage
            className={classNames(styles.messageItem, messageClassName)}
            key={message.id}
            id={message.id}
            treeView={treeView}
            level={minimiseLevels === true ? message.level + 1 - minLevel : message.level}
            expandable={treeView === true && message.containsMessages === true}
            expanded={treeView === true && (messages[index + 1]?.level ?? 0) > message.level}
            text={message.text}
            duration={message.duration}
            status={message.status}
            blockType={message.blockType}
            parseAnsi={message.containAnsi}
            parseLinks={parseLinks && message.containUrl}
            breakLines={breakLines}
            verbose={message.verbose}
            showDuration={withDuration === true && showDuration(message)}
            timestamp={message.timestamp}
          />
        ))}
      </div>
    )
  }
}

export default BuildLogMessages
